import { useI18n } from '@change-corgi/core-react/i18n';
import { useKnownAvailableParams, useNavigate } from '@change-corgi/core-react/router';

import { calculateImpressions } from '#src/app/shared/utils/promote';

import { usePromoteFormData } from '../../../formContext/formData';
import { usePromoteFormState } from '../../../formContext/formState';

export function useNavigateToThankYouPage(): () => void {
	const { amountToBaseUnits } = useI18n();
	const navigate = useNavigate();
	const { slug } = useKnownAvailableParams<{ slug: string }>();

	const {
		promotionSettings: { cpm, bonusCpm, bonusThreshold },
		currency,
	} = usePromoteFormData();
	const [{ amount }] = usePromoteFormState();

	return function navigateToThankYouPage(): void {
		const amountInUrl = amount.toString();
		navigate(
			`/p/${slug}/promote/thank_you?amount=${amountInUrl}&impressions=${calculateImpressions(
				amountToBaseUnits(amount, currency.code),
				cpm,
				bonusCpm,
				bonusThreshold,
			)}`,
			{
				forceMode: 'internal',
			},
		);
	};
}
